export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum ModalType {
	ERROR,
	CONFIRM,
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Completed = "completed",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum Locale {
	EN_US = "en-US",
}

export enum Language {
	EN = "en",
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum LeagueType {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	COMPLETED = "completed",
	PLAYING = "playing",
	SCHEDULED = "scheduled",
}

export enum PlayerPosition {
	GK = "GK",
	DEF = "DEF",
	MID = "MID",
	FWD = "FWD",
}

export enum PlayerStatus {
	Playing = "playing",
	Injured = "injured",
	Suspended = "suspended",
	Eliminated = "eliminated",
}

export enum GameStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "completed",
	Postponed = "postponed",
}
